import { UIMatch, useMatches } from 'react-router';
import { Link } from '@outdoria/ui';
import { RouteHandle } from '../../../router/types';

import s from './Breadcrumbs.module.scss';

export type BreadcrumbType = { link: string; title: string };

export const Breadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumbs();

  return (
    <div className={s.breadcrumbs}>
      {breadcrumbs.map((breadcrumb, index) => (
        <Breadcrumb
          key={index}
          breadcrumb={breadcrumb}
          isLast={index === breadcrumbs.length - 1}
        />
      ))}
    </div>
  );
};

type BreadcrumbProps = { breadcrumb: BreadcrumbType; isLast: boolean };
const Breadcrumb = ({ breadcrumb, isLast }: BreadcrumbProps) => (
  <>
    <Link to={breadcrumb.link} className={s.breadcrumb}>
      {breadcrumb.title}
    </Link>
    {!isLast && <span> &gt; </span>}
  </>
);

const useBreadcrumbs = () => {
  const matches = useMatches();

  const breadcrumbs: BreadcrumbType[] = matches
    .map((match: UIMatch) => ({
      link: match.pathname,
      title: (match?.handle as RouteHandle)?.title ?? null,
    }))
    .filter(breadcrumb => breadcrumb.title);

  return { breadcrumbs };
};
